import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_67 } from "@/lib/programData";
export default function DesiertoAtlas67Page() {
  return <ProgramTemplate program={PROGRAM_67} variant="da" showJourneyChronology />;
}
